var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAligncenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57995 2.21684H10.2315C10.2994 2.21684 10.3549 2.15408 10.3549 2.07739V1.10124C10.3549 1.02454 10.2994 0.961792 10.2315 0.961792H2.57995C2.51207 0.961792 2.45653 1.02454 2.45653 1.10124V2.07739C2.45653 2.15408 2.51207 2.21684 2.57995 2.21684ZM10.2315 9.60765C10.2994 9.60765 10.3549 9.54489 10.3549 9.4682V8.49205C10.3549 8.41535 10.2994 8.3526 10.2315 8.3526H2.57995C2.51207 8.3526 2.45653 8.41535 2.45653 8.49205V9.4682C2.45653 9.54489 2.51207 9.60765 2.57995 9.60765H10.2315ZM12.453 12.048H0.35852C0.290643 12.048 0.235107 12.1108 0.235107 12.1875V13.1636C0.235107 13.2403 0.290643 13.3031 0.35852 13.3031H12.453C12.5208 13.3031 12.5764 13.2403 12.5764 13.1636V12.1875C12.5764 12.1108 12.5208 12.048 12.453 12.048ZM12.453 4.6572H0.35852C0.290643 4.6572 0.235107 4.71995 0.235107 4.79665V5.77279C0.235107 5.84949 0.290643 5.91224 0.35852 5.91224H12.453C12.5208 5.91224 12.5764 5.84949 12.5764 5.77279V4.79665C12.5764 4.71995 12.5208 4.6572 12.453 4.6572Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAligncenter);
export default __webpack_public_path__ + "static/media/aligncenter.476bfd156b26d154deebf4774dc5ff4a.svg";
export { ForwardRef as ReactComponent };